import ErrorComponent from "@/components/atoms/ErrorComponent";
import CompanyStatsSection from "@/components/molecules/cards/dashboard/CompanyStatsSection";
import GeneralDossierStatsSection from "@/components/molecules/cards/dashboard/GeneralDossierStatsSection";
import MeetingStatsSection from "@/components/molecules/cards/dashboard/MeetingStatsSection";
import PerformanceStatsSection from "@/components/molecules/cards/dashboard/PerformanceStatsSection";
import SignatureStatsSection from "@/components/molecules/cards/dashboard/SignatureStatsSection";
import { isStrictAdmin } from "@/helpers/UserHelpers";
import { selectCurrentUser } from "@/services/slices/authSlice";
import {
  faBuilding,
  faCalendar,
  faChartLine,
  faChartPie,
  faFileSignature,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC } from "react";
import { Card, Nav, Tab } from "react-bootstrap";
import { useSelector } from "react-redux";

const DashboardView: FC = () => {
  const currentUser = useSelector(selectCurrentUser);

  if (!isStrictAdmin(currentUser)) {
    return (
      <ErrorComponent error={{ status: 403, data: {} }} absolute returnButton />
    );
  }

  return (
    <div className="container-fluid py-4 formalys-dashboard">
      <div className="formalys-page-heading d-flex flex-wrap align-items-end justify-content-between gap-3 mb-4">
        <div>
          <p className="formalys-eyebrow mb-2">Vue d’ensemble</p>
          <h1 className="mb-2">Pilotage Formalys</h1>
          <p className="text-muted mb-0">
            Suivez l’activité commerciale et administrative de votre équipe.
          </p>
        </div>
        <span className="formalys-live-pill">
          <span className="formalys-live-dot" aria-hidden="true" />
          Données en direct
        </span>
      </div>
      <Card className="formalys-dashboard-card">
        <Tab.Container defaultActiveKey="general">
          <Card.Header className="p-0 border-bottom">
            <Nav className="nav-tabs border-0 flex-nowrap">
              <Nav.Item>
                <Nav.Link
                  eventKey="general"
                  className="d-flex align-items-center py-3 px-x1 mb-0"
                >
                  <FontAwesomeIcon
                    icon={faChartPie}
                    className="text-600 tab-icon"
                  />
                  <h6 className="text-600 mb-0 ms-1">Général</h6>
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  eventKey="performance"
                  className="d-flex align-items-center py-3 px-x1 mb-0"
                >
                  <FontAwesomeIcon
                    icon={faChartLine}
                    className="text-600 tab-icon"
                  />
                  <h6 className="text-600 mb-0 ms-1">Performance commerciale</h6>
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  eventKey="companies"
                  className="d-flex align-items-center py-3 px-x1 mb-0"
                >
                  <FontAwesomeIcon
                    icon={faBuilding}
                    className="text-600 tab-icon"
                  />
                  <h6 className="text-600 mb-0 ms-1">Entreprises</h6>
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  eventKey="meetings"
                  className="d-flex align-items-center py-3 px-x1 mb-0"
                >
                  <FontAwesomeIcon
                    icon={faCalendar}
                    className="text-600 tab-icon"
                  />
                  <h6 className="text-600 mb-0 ms-1">Calendrier</h6>
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  eventKey="signatures"
                  className="d-flex align-items-center py-3 px-x1 mb-0"
                >
                  <FontAwesomeIcon
                    icon={faFileSignature}
                    className="text-600 tab-icon"
                  />
                  <h6 className="text-600 mb-0 ms-1">Signatures</h6>
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Card.Header>
          <Card.Body className="formalys-dashboard-body">
            <Tab.Content>
              <Tab.Pane eventKey="general">
                <GeneralDossierStatsSection />
              </Tab.Pane>
              <Tab.Pane eventKey="performance" mountOnEnter unmountOnExit>
                <PerformanceStatsSection />
              </Tab.Pane>
              <Tab.Pane eventKey="companies" mountOnEnter unmountOnExit>
                <CompanyStatsSection />
              </Tab.Pane>
              <Tab.Pane eventKey="meetings" mountOnEnter unmountOnExit>
                <MeetingStatsSection />
              </Tab.Pane>
              <Tab.Pane eventKey="signatures" mountOnEnter unmountOnExit>
                <SignatureStatsSection />
              </Tab.Pane>
            </Tab.Content>
          </Card.Body>
        </Tab.Container>
      </Card>
    </div>
  );
};

export default DashboardView;
